import React, { memo } from 'react'
import { Path, Circle as _Circle, Rect } from 'react-native-svg'

import { IconProps } from '../IconProps'
import { IconBase } from '../IconBase'
import { themed } from '../themed'

const Icon = (props) => {
  const { size = 24, ...otherProps } = props
  return (
    <IconBase
      width={size}
      height={size}
      viewBox="0 0 75 74"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <Rect x={0.998} width={74.002} height={74} rx={37} fill="#A4A89B" />
      <Path
        d="M38.914 38.246a1.544 1.544 0 0 1-1.828 0l-12.995-9.53L21 26.45 21 48.333c0 .854.692 1.546 1.545 1.546h30.91c.853 0 1.545-.692 1.545-1.546V26.45l-3.091 2.267-12.995 9.53Z"
        fill="#fff"
      />
      <Path d="M38 35.084 52.947 24.12H23.05l14.948 10.963Z" fill="#fff" />
    </IconBase>
  )
}

Icon.displayName = 'IconEmailCircle'

export const IconEmailCircle = memo<IconProps>(themed(Icon))
